<template>
    <div class="card">
        <div class="card-body p-5">
            <draggable
                class="list-group"
                tag="ul"
                v-model="listGallery"
                v-bind="dragOptions"
                @start="isDragging = true"
                @end="isDragging = false">
                <transition-group type="transition" name="flip-list">
                <li class="card list-group-item p-2 ml-2 mr-2 mb-5" v-for="element in listGallery" :key="element.id">
                    <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end">
                        <div class="text-primary">
                            <a class="link" @click="deleteImage(element)">
                                <i class="fal fa-trash"></i>
                            </a>
                        </div>
                    </div>
                    <i :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click="element.fixed = !element.fixed" aria-hidden="true"></i>
                    <img class="img-fluid img-item" :src="getImage(element.path)"/>
                </li>
                </transition-group>
            </draggable>
            <div class="mt-3">
                <vue-dropzone id="dropLogo" ref="dropzone" class="text-center mt-3 mb-5" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
            </div>
            <div class="text-left border-top pt-5">
                <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mr-3" @click="returnPreviousStep">{{$t('button_link.prev')}}</button>
                <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitGallery">{{$t('button_link.done')}}</button>
            </div>
        </div>
    </div>
</template>
<script>
import vueDropzone from "vue2-dropzone";
import draggable from "vuedraggable";
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'setupGallery',
    components:{
        vueDropzone, draggable
    },
    props:{
        outletID: {type: Number},
        gallery: { type: Array}
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    data(){
        return{
            step: 5,
            listGallery: [],
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },
        }
    },
    methods:{
        closeModal(){
            this.$parent.$parent.isModalShow = false
        },
        getImage(path){
            return path
        },
        deleteImage(item){
            this.listGallery = this.listGallery.filter(obj=> obj.id != item.id)
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }else{
                this.listGallery.push({
                    order: this.listGallery.length + 1,
                    id: 'gallery_' + this.listGallery.length + 1,
                    path: response.path
                })
            }
            this.listGallery.sort((a, b) => a.order - b.order);
            this.$refs.dropzone.removeFile(file)
        },
        returnPreviousStep(){
            this.$emit('returnPreviousStep', this.step);
        },
        submitGallery(){
            let $vm = this
            var data = []
            for(var i=0; i<this.listGallery.length; i++){
                data.push(this.listGallery[i].path)
            }

            let url = this.$api.OUTLET + "/" + this.outletID + this.$api.INFO
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: {gallery: data},
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.$emit('submitGallery', $vm.step);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true,  $vm.$i18n.t('message.error.system_error'));
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        for(var i=0; i<$vm.gallery.length; i++){
            $vm.listGallery.push({
                order: i,
                id: 'gallery_' + i,
                path: $vm.gallery[i]
            })
        }
        $vm.listGallery.sort((a, b) => a.order - b.order);
    },
}
</script>
<style scoped>
.img-item{
    width: 13em;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    display: inline-block;
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
</style>